export default __webpack_public_path__ + "static/media/chaise-rounded-rectangle-3-breaks.53987eb1.webp";